/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const DataSearchAPI = {
  getAllSearchFilters: async() =>
    (await initAxios())
      ?.get('/data-search')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getUserSearchFilters: async(query: any) =>
    (await initAxios())
      ?.post('/data-search/user', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getSearchFilter: async(SearchFilter_id: string) =>
    (await initAxios())
      ?.get(`/data-search/${SearchFilter_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateSearchFilter: async(SearchFilterBody: any) =>
    (await initAxios())
      ?.put('/data-search', JSON.stringify(SearchFilterBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createSearchFilter: async(SearchFilterBody: any) =>
    (await initAxios())
      ?.post('/data-search', JSON.stringify(SearchFilterBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteSearchFilter: async(SearchFilter_id: string) =>
    (await initAxios())
      ?.delete(`/data-search/${SearchFilter_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default DataSearchAPI;
